import { CssBaseline, Tooltip } from "@material-ui/core";
import { useSelector } from "react-redux";
import ReactSpinnerTimer from "react-spinner-timer";
import { AddRounded } from "@material-ui/icons";

import ErrorBoundary from "../ProtectedRoute/ErrorBoundary";
import GeneralError from "../ProtectedRoute/components/GeneralError";
import AppLayout from ".";
import PageHeader from "./components/PageHeader";
import { handleRoleActionAccess } from "../../utils/userRoleEvaluation";

const MainPageLayout = ({
  headerTitle,
  pageTitle,
  pageSubtitle,
  categories,
  isNotMainPages,
  isLoading,
  handleChange,
  topBar,
  hideSearbar,
  hasGoBack,
  hideSubtitle,
  onAddNew,
  children,
}) => {
  const { user } = useSelector(({ auth }) => auth);

  return (
    <ErrorBoundary render={() => <GeneralError />}>
      <div>
        <CssBaseline />
        <AppLayout
          headerTitle={headerTitle}
          pageTitle={pageTitle}
          hideSearbar={hideSearbar}
        >
          <div className="main-page-layout-outer">
            <div
              className="main-page-layout-inner"
              style={{
                backgroundColor: isNotMainPages ? "#FFFFFF" : "#F4F8FF",
              }}
            >
              <PageHeader
                pageTitle={pageTitle}
                pageSubtitle={pageSubtitle}
                categories={categories}
                hasGoBack={hasGoBack}
                hideSubtitle={hideSubtitle}
                topBar={topBar}
              />

              {/* here for the main area and contents */}
              {children}
              {isLoading && (
                <div className="page-spinner-loader">
                  <ReactSpinnerTimer
                    timeInSeconds={3}
                    totalLaps={100}
                    isRefresh={false}
                    onLapInteraction={handleChange}
                  />
                </div>
              )}
            </div>
          </div>
        </AppLayout>

        {!!onAddNew &&
          handleRoleActionAccess({ pageTitle, headerTitle }, "POST") && (
            <>
              <Tooltip title={onAddNew?.tooltip}>
                <div
                  data-testid="createButton"
                  className="floatingCircularBtn"
                  onClick={onAddNew?.fn}
                >
                  <AddRounded style={{ fontSize: 34 }} />
                </div>
              </Tooltip>
              {onAddNew?.menu}
            </>
          )}
      </div>
    </ErrorBoundary>
  );
};

export default MainPageLayout;
